import React from 'react';
import {Link} from "wouter";
import RenderPlatformIcon from "../../components/RenderPlatformIcon.tsx";
import BackButton from "../../components/BackButton.tsx";
import {useDocumentTitle} from "usehooks-ts";

function  LinkItem({platform, title, to}){
    return (
        <Link to={to} className="py-3 flex items-center gap-2 px-4 duration-100 hover:translate-x-3 hover:scale-105 hover:text-primary">
            <RenderPlatformIcon platform={platform} />
            {title}
        </Link>
    )
}

function TypeOfPostChooser() {
    useDocumentTitle("Choose a post type")
    return (
        <div>
            <BackButton />
            <h2 className={"text-2xl mb-1"}>Post type</h2>
            <p className={"mb-3"}>Choose the type of post you want to schedule / publish</p>
                <ul className="card bg-base-100 overflow-hidden w-96 divide divide-y  divide-base-200 border border-base-200 shadow">
                    <LinkItem platform={"instagram"} title={"Instagram Post"} to={"/posts/create/instagram-post"} />
                    <LinkItem platform={"instagram"} title={"Instagram Reel"} to={"/posts/create/instagram-reel"} />
                    <LinkItem platform={"instagram"} title={"Instagram Story"} to={"/posts/create/instagram-story"} />
                    <LinkItem platform={"facebook"} title={"Facebook Page Post"} to={"/posts/create/facebook-page-post"} />
                    {/*<LinkItem platform={"facebook"} title={"Facebook Page Story"} to={"/posts/create/facebook-page-story"} />*/}
                    {/*<LinkItem platform={"facebook"} title={"Facebook Page Reel"} to={"/posts/create/facebook-page-reel"} />*/}
                    <LinkItem platform={"twitter"} title={"Tweet / Tweet Thread"} to={"/posts/create/twitter-post"} />
                </ul>
        </div>
    );
}


export default TypeOfPostChooser;
